<template>
    <div>
        <ButtonSelectField
            :customErrorMessage="errorMessage"
            :multiple="multiple"
            :name="name"
            :options="options"
            :validationRules="validationRules"
            @input="inputSelected"
            buttonClasses="wizard-button"
        />
    </div>
</template>

<script>
import { useStore } from 'vuex'

// lodash components
import filter from 'lodash/filter'
import concat from 'lodash/concat'
import map from 'lodash/map'
import remove from 'lodash/remove'
import startsWith from 'lodash/startsWith'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'financesBank',
            hideContinue: true,
            route: {
                relativeUrl: process.env.TERRITORY === 'pol' ? `prosze-wybierz-swoj-bank-z-listy` : `bank`,
                name: 'apply.financesBank',
                meta: {
                    title: 'form.sections.finances.nameOfBank',
                    layoutType: 'large',
                },
            },
            fields: {
                nameOfBank: {
                    value: null,
                    mappedKey: 'name_of_bank',
                    validationRules: {
                        required: true,
                    },
                },
            },
        }
    },

    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    data() {
        return {
            name: 'nameOfBank',
            otherLabel: this.$t('form.fields.nameOfBank.otherLabel'),
            errorMessage: this.$t('form.fields.nameOfBank.errorMessage'),
            loading: false,
            multiple: false,
            validationRules: this.store.getters.fieldValidationRules('nameOfBank'),
            options: [],
        }
    },
    created() {
        this.emitter.emit('stepLoaded')
    },
    mounted() {
        if (this.value) {
            this.store.dispatch('updateStepSetting', {
                setting: 'hideContinue',
                settingValue: false,
                step: this.store.state.apply.currentRouteStep
            })
        }

        if (this.banks) {
            this.mapOptions(this.banks)
        }
    },
    computed: {
        value: function () {
            return this.store.getters.fieldValue(this.name)
        },
        banks: function () {
            return this.store.state.global.data.banks || []
        },
    },
    methods: {
        mapOptions(responseData) {
            const allOptions = filter(
                responseData,
                item => !startsWith(item.name, 'Inne') && !startsWith(item.name, 'Other'),
            )
            const otherOptions = filter(
                responseData,
                item => startsWith(item.name, 'Inne') || startsWith(item.name, 'Other'),
            )

            let options = map([...allOptions, ...otherOptions], option => {
                return {
                    id: option.id,
                    code: option.code,
                    value: option.code ?? option.id,
                    name: option.name,
                    logo: option.image,
                }
            })

            const other = remove(options, option => {
                return option.name === this.otherLabel
            })

            if (other) {
                options = concat(options, other)
            }

            this.options = options
        },
        inputSelected(option) {
            this.emitter.emit('nextStep')
        },
    },
}
</script>
